import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
import "./css/global.css";

ReactDOM.render(<App />, document.getElementById('root'));